/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useContext, useEffect } from "react";
import { useToasts } from "react-toast-notifications";
import { Link } from "react-router-dom";

import FoodImg from "../../assets/images/img/no-image-available.png";
import { FoodContext } from "../../contexts/FoodContext";
import {
  addToCart,
  getCartItems,
  removeFromCart,
  getOrgDetails,
} from "../../utils/sessionManager";
import { mergeAndRemoveDuplicateByKeyname } from "../../utils";
import FOOD_ACTIONS from "../../actions/food";

import { appService } from "../../services/appService";
import { useTranslation } from "react-i18next";
import { getValue } from "../../utils/object";
import { getSelectedLanguage } from "../../utils/localStorage";
import { translateTextToTargetLanguage } from "../../services/googleTranslate";
import DietaryBadges from "./DieteryBadge";

const MAX_ORDER = 15;
const MIN_ORDER = 1;
const orgDetails = getOrgDetails();

export default function Details(props) {
  const foodId = props.match.params.id;
  const { addToast } = useToasts();
  const selectedLang = getSelectedLanguage();

  const { t } = useTranslation();

  const translation = t("foodMenuDetails", {
    MAX_ORDER: MAX_ORDER,
    MIN_ORDER: MIN_ORDER,
  });

  const { getFoodDetails, dispatch, currentCartIDs } = useContext(FoodContext);
  const newCartItems = [];

  const [foodDetails, setFoodDetails] = useState(null);

  const [translatedFoodDetails, setTranslatedFoodDetails] = useState({
    name: "",
    description: "N/A",
  });

  const [foodCount, setFoodCount] = useState(1); // Cart count
  const [menuOptionSelect, setMenuOptionSelect] = useState("");
  const [specialInstruction, setSpecialInstruction] = useState("");
  const [optionPrice, setOptionPrice] = useState(null);

  const fetchCurrentCartIds = () => {
    const data = getCartItems() || [];
    const IDs = data.length ? data.map((item) => item.foodMenuId) : [];
    dispatch({ type: FOOD_ACTIONS.SET_CURRENT_CART, data: IDs });
  };

  const getExistingCart = () => {
    let data = getCartItems();
    if (!data) return [];
    return data;
  };

  const handleRemoveFromCart = (e, foodMenuId) => {
    e.preventDefault();
    removeFromCart(foodMenuId);
    dispatch({ type: FOOD_ACTIONS.SET_CART_COUNT, data: null });
    fetchCurrentCartIds();
  };

  const saveToMyCart = (payload) => {
    const existingCartItems = getExistingCart();
    newCartItems.push(payload);
    const mergedData = mergeAndRemoveDuplicateByKeyname(
      existingCartItems,
      newCartItems,
      "foodMenuId"
    );
    addToCart(mergedData);
    dispatch({ type: FOOD_ACTIONS.SET_CART_COUNT });
  };

  const handleAddToCart = (e) => {
    e.preventDefault();
    const defaultPrice = foodDetails.price || 0;
    const payload = {
      name: foodDetails.name,
      foodMenuId: foodDetails._id,
      menuId: getValue(foodDetails, "menuId"),
      image: foodDetails.image,
      price: optionPrice ? optionPrice : defaultPrice,
    };
    payload.selectedOption = `${menuOptionSelect}`;
    payload.instruction = specialInstruction;
    payload.quantity = foodCount;
    saveToMyCart(payload);
    appService.goBack();
  };

  const fetchFoodDetails = () => {
    getFoodDetails(foodId)
      .then((data) => {
        setFoodDetails(data.data);
        setTranslatedFoodDetails({
          name: getValue(data, "data.name"),
          description: getValue(data, "data.description", "N/A"),
        });
      })
      .catch(() => {
        addToast("Internal server error!", {
          autoDismiss: true,
          appearance: "error",
        });
      });
  };

  const foodCountUp = () => {
    if (foodCount >= MAX_ORDER) {
      return addToast(getValue(translation, "maxOrderAllowed"), {
        autoDismiss: true,
        appearance: "error",
      });
    }
    setFoodCount(foodCount + 1);
  };

  const foodCountDown = () => {
    if (foodCount <= MIN_ORDER) {
      return addToast(getValue(translation, "minOrderAllowed"), {
        autoDismiss: true,
        appearance: "error",
      });
    }
    setFoodCount(foodCount - 1);
  };

  const handleMenuOptionChange = (e, price) => {
    setOptionPrice(price);
    setMenuOptionSelect(e.target.value);
  };

  const handleSpecialInstructionChange = (e) => {
    setSpecialInstruction(e.target.value);
  };

  const translateFoodDetails = async () => {
    if (selectedLang === "en") {
      setTranslatedFoodDetails({
        name: getValue(foodDetails, "name"),
        description: getValue(foodDetails, "description"),
      });
      return;
    }

    const [translatedDescription] = await Promise.all([
      // translateTextToTargetLanguage({
      //   text: getValue(foodDetails, "name"),
      //   targetLang: selectedLang,
      // }),
      translateTextToTargetLanguage({
        text: getValue(foodDetails, "description"),
        targetLang: selectedLang,
      }),
    ]);

    setTranslatedFoodDetails((prev) => ({
      ...prev,
      description: translatedDescription,
    }));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fetchFoodDetails, []);
  useEffect(fetchCurrentCartIds, []);

  useEffect(() => {
    translateFoodDetails();
  }, [selectedLang, foodDetails]);

  return (
    <>
      <section className="single_page_area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-10 offset-md-1">
              <div className="single_fpage_area">
                <div className="single_fbanner">
                  <img
                    src={
                      foodDetails && foodDetails.image
                        ? foodDetails.image
                        : FoodImg
                    }
                    alt="food"
                  />
                </div>
                <div className="single_page_box">
                  <div className="items_gap">
                    <div className="box_shadow single_page">
                      <div className="single_page_content">
                        <h1>{translatedFoodDetails.name}</h1>
                        <h1>
                          {orgDetails ? orgDetails.currency : "USD"} &nbsp;
                          {(foodDetails && foodDetails.price) || 0}
                        </h1>

                        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", width: "100%", marginTop: "10px" }}>
                          <DietaryBadges dietaryRestrictions={foodDetails?.dietaryRestrictions} />
                          {foodDetails?.preparationTime && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                backgroundColor: "#f3f4f6",
                                padding: "4px 10px",
                                borderRadius: "12px",
                              }}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                                <path d="M4 1.33333V-9.53674e-07H8V1.33333H4ZM5.33333 8.66667H6.66667V4.66667H5.33333V8.66667ZM6 14C5.17778 14 4.40278 13.8417 3.675 13.525C2.94722 13.2083 2.31111 12.7778 1.76667 12.2333C1.22222 11.6889 0.791667 11.0528 0.475 10.325C0.158333 9.59722 0 8.82222 0 8C0 7.17778 0.158333 6.40278 0.475 5.675C0.791667 4.94722 1.22222 4.31111 1.76667 3.76667C2.31111 3.22222 2.94722 2.79167 3.675 2.475C4.40278 2.15833 5.17778 2 6 2C6.68889 2 7.35 2.11111 7.98333 2.33333C8.61667 2.55556 9.21111 2.87778 9.76667 3.3L10.7 2.36667L11.6333 3.3L10.7 4.23333C11.1222 4.78889 11.4444 5.38333 11.6667 6.01667C11.8889 6.65 12 7.31111 12 8C12 8.82222 11.8417 9.59722 11.525 10.325C11.2083 11.0528 10.7778 11.6889 10.2333 12.2333C9.68889 12.7778 9.05278 13.2083 8.325 13.525C7.59722 13.8417 6.82222 14 6 14ZM6 12.6667C7.28889 12.6667 8.38889 12.2111 9.3 11.3C10.2111 10.3889 10.6667 9.28889 10.6667 8C10.6667 6.71111 10.2111 5.61111 9.3 4.7C8.38889 3.78889 7.28889 3.33333 6 3.33333C4.71111 3.33333 3.61111 3.78889 2.7 4.7C1.78889 5.61111 1.33333 6.71111 1.33333 8C1.33333 9.28889 1.78889 10.3889 2.7 11.3C3.61111 12.2111 4.71111 12.6667 6 12.6667Z" fill="#4B5563" />
                              </svg>
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: "#4b5563",
                                  lineHeight: "16px",
                                }}
                              >
                                {foodDetails.preparationTime} min
                              </span>
                            </div>
                          )}
                        </div>
                        <p>{translatedFoodDetails.description}</p>
                      </div>
                    </div>
                  </div>

                  {foodDetails &&
                    foodDetails.options &&
                    foodDetails.options.length > 0 && (
                      <div className="items_gap">
                        <div className="box_shadow single_page">
                          <div className="cooking_style">
                            <h1>{getValue(translation, "selectOption")}</h1>
                          </div>
                          <div className="cooking_style_list">
                            <ul>
                              {foodDetails.options.map((item) => (
                                <li key={item.id}>
                                  <input
                                    type="radio"
                                    id={item.id}
                                    name="selectOption"
                                    value={item.name}
                                    onChange={(e) =>
                                      handleMenuOptionChange(e, item.price)
                                    }
                                  />
                                  <label htmlFor={item.id}>
                                    {item.name} - {item.price || 0}
                                  </label>
                                  <div className="check" />
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                  <div className="items_gap">
                    <div className="box_shadow single_page">
                      <div className="single_page_content add_class2">
                        <h1>{getValue(translation, "specialInstruction")}</h1>

                        <textarea
                          value={specialInstruction}
                          name="specialInstruction"
                          placeholder={getValue(
                            translation,
                            "specialInstructionPlaceholder"
                          )}
                          rows="1"
                          onChange={handleSpecialInstructionChange}
                        />
                      </div>
                    </div>
                  </div>

                  {/* HIDDEN ADDON DIV */}
                  <div className="items_gap">
                    <div className="box_shadow single_page">
                      <div className="quantity_counter_area">
                        <div className="quantity_counter">
                          <button
                            onClick={foodCountDown}
                            id="counter_decrement"
                            className="decrement"
                          />
                          <input
                            id="counter_value"
                            className="value"
                            type="number"
                            value={foodCount}
                            readOnly
                          />
                          <button
                            onClick={foodCountUp}
                            id="counter_increment"
                            className="increment"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="single_pbutton">
                    {foodDetails &&
                      currentCartIDs &&
                      currentCartIDs.indexOf(foodDetails._id) > -1 ? (
                      <Link
                        to="#remove_from_cart"
                        onClick={(e) => {
                          handleRemoveFromCart(e, foodDetails._id);
                        }}
                      >
                        {getValue(translation, "removeItem")}
                      </Link>
                    ) : (
                      <Link
                        to="#add_to_cart"
                        onClick={(e) => handleAddToCart(e)}
                      >
                        {getValue(translation, "addItem")}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
